import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import './ToolPage.css'
import './UrlShortenerStats.css'
import { fetchShortLinkStats } from './utils/shortLinkStore'
import { useDocumentMeta } from '../../hooks/useDocumentMeta'

const DAYS_SHOWN = 14

const lastDays = (n) => {
  const days = []
  const today = new Date()
  for (let i = n - 1; i >= 0; i--) {
    const d = new Date(today)
    d.setUTCDate(d.getUTCDate() - i)
    days.push(d.toISOString().slice(0, 10))
  }
  return days
}

const UrlShortenerStats = () => {
  useDocumentMeta({
    title: 'Estatísticas do link curto | jarder.dev',
    description: 'Cliques do seu link curto, contados no servidor, e prévia do destino.',
  })

  const { id } = useParams()
  const [stats, setStats] = useState(null)
  const [status, setStatus] = useState('loading')

  useEffect(() => {
    let cancelled = false
    fetchShortLinkStats(id).then((data) => {
      if (cancelled) return
      if (data) {
        setStats(data)
        setStatus('ready')
      } else {
        setStatus('notfound')
      }
    })
    return () => {
      cancelled = true
    }
  }, [id])

  if (status === 'loading') {
    return (
      <div className="tool-page">
        <p>Carregando...</p>
      </div>
    )
  }

  if (status === 'notfound') {
    return (
      <div className="tool-page">
        <Link to="/ferramentas/encurtador-url" className="tool-back-link">
          ← Todas as ferramentas
        </Link>
        <h1>Link não encontrado</h1>
        <p className="tool-disclaimer">Esse link curto não existe ou já expirou.</p>
      </div>
    )
  }

  const days = lastDays(DAYS_SHOWN)
  const counts = days.map((day) => stats.clicksByDay[day] || 0)
  const maxCount = Math.max(1, ...counts)

  return (
    <div className="tool-page">
      <Link to="/ferramentas/encurtador-url" className="tool-back-link">
        ← Todas as ferramentas
      </Link>
      <h1>Estatísticas do link curto</h1>
      <p className="tool-disclaimer">
        Cliques contados no servidor, sem coletar dados de quem clica —
        só o total por dia.
      </p>

      <div className="tool-result-card">
        <span className="tool-result-label">Destino</span>
        <span className="tool-result-value" style={{ wordBreak: 'break-all' }}>
          {stats.url}
        </span>
      </div>

      <p className="url-stats-total">
        <strong>{stats.clicks}</strong> {stats.clicks === 1 ? 'clique' : 'cliques'} no total
      </p>

      <div className="url-stats-chart" role="img" aria-label={`Cliques nos últimos ${DAYS_SHOWN} dias`}>
        {days.map((day, i) => (
          <div className="url-stats-bar-wrap" key={day} title={`${day}: ${counts[i]} ${counts[i] === 1 ? 'clique' : 'cliques'}`}>
            <div
              className="url-stats-bar"
              style={{ height: `${(counts[i] / maxCount) * 100}%` }}
            />
            <span className="url-stats-bar-label">{day.slice(8, 10)}</span>
          </div>
        ))}
      </div>

      {stats.preview && (stats.preview.title || stats.preview.image) && (
        <div className="url-stats-preview">
          {stats.preview.image && (
            <img src={stats.preview.image} alt="" className="url-stats-preview-image" />
          )}
          <div className="url-stats-preview-text">
            {stats.preview.title && <strong>{stats.preview.title}</strong>}
            {stats.preview.description && <p>{stats.preview.description}</p>}
          </div>
        </div>
      )}
    </div>
  )
}

export default UrlShortenerStats
